import script from "./MapElemInfoCommentContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./MapElemInfoCommentContainer.vue?vue&type=script&setup=true&lang=ts"

import "./MapElemInfoCommentContainer.vue?vue&type=style&index=0&id=5609102e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5609102e"]])

export default __exports__